import React from 'react';
import {Box, Text, VStack} from "@chakra-ui/react";
import {INFO_EMAIL} from "../constants";

const Footer = () => {
    return (
        <Box bg="white" boxShadow="md" py={4} as="footer" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <VStack width={["90%", "80%", "70%", "60%"]}>
                <Text fontSize="sm !important" color={"black !important"} lineHeight="tall">
                  Solar energy is a renewable source that reduces electricity bills and carbon footprints. Harness the sun for clean, affordable energy.
                </Text>

                <Text fontSize="xs !important" color="gray.600 !important">
                    Disclaimer: This page is for advertorial purposes only. Offers may vary by region.
                </Text>

                <Text fontSize="xs !important" color="gray.600 !important">
                  © {new Date().getFullYear()} <strong>SolarRoots Ltd.</strong> All rights reserved.
                </Text>

                <Text fontSize="xs !important" color="gray.600 !important">
                  Contact us: <a href={`mailto:${INFO_EMAIL}`}>{INFO_EMAIL}</a>
                </Text>
            </VStack>
        </Box>
    );
};

export default Footer;